export const DEFAULT_SIZE_ITEMS = [
  { name: 'Alla storlekar', value: null },
  { name: 'Små', value: 'small', subName: '(0-40 kvm)' },
  { name: 'Mellan', value: 'medium', subName: '(40-80 kvm)' },
  { name: 'Stora', value: 'large', subName: '(80+ kvm)' },
];
